import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import DeepEquals from 'deep-equal';
import { of } from 'rxjs';
import {
    distinctUntilChanged,
    map,
    switchMap,
    withLatestFrom
} from 'rxjs/operators';
import { RouterService } from '@classifieds-sell/shared';
import * as RouterActions from './router.actions';
import { IRouterState } from './router.models';

@Injectable()
export class RouterEffects {
    constructor(
        private _actions$: Actions,
        private _activatedRoute: ActivatedRoute,
        private _routerService: RouterService
    ) {}

    routerStateUpdatedAction$ = createEffect(() =>
        this._actions$.pipe(
            ofType(RouterActions.ngRouterStateUpdatedAction),
            switchMap((action) =>
                of(action).pipe(
                    withLatestFrom(
                        this._activatedRoute.queryParams,
                        this._activatedRoute.fragment
                    )
                )
            ),
            map(([action, , fragment]): IRouterState => {
                const { id, urlAfterRedirects } = action.event;
                const fullUrl = urlAfterRedirects;
                const url = this._routerService.extractUrl(urlAfterRedirects);
                const canonicalPath =
                    this._routerService.extractCanonicalPath(url);
                const { params, data } =
                    this._routerService.extractRouteMetaData(
                        this._activatedRoute
                    );

                return {
                    id,
                    queryParams: action.queryParams,
                    params: {
                        ...params,
                        canonicalPath
                    },
                    data,
                    url,
                    fullUrl,
                    fragment
                };
            }),
            distinctUntilChanged((prev, next) => DeepEquals(prev, next)),
            switchMap((routerState) => {
                return [
                    RouterActions.updateRouterStateAction({
                        router: routerState
                    })
                ];
            })
        )
    );
}
